import { routeReducer } from "@bapp/webcore"

const rootReducers = {
  routing: routeReducer
}

export default rootReducers
